module.exports = __webpack_public_path__ + "img/thermo.e12a9aca.png";